import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";
import roles from "constants/roles.constant";

import Info from "./Info";
import AvailableDialog from "./AvailableDialog";
import BalanceDialog from "./BalanceDialog";

type SrUserBalanceProps = {
  textDirection?: string;
  size?: string;
};

const SrUserBalance = ({
  textDirection = "row",
  size = "normal",
}: SrUserBalanceProps) => {
  // @ts-ignore
  const funds = useSelector(({ app }) => app.funds);
  // @ts-ignore
  const userRole = useSelector(({ auth }) => auth.role);
  const [balanceIsOpen, setBalanceIsOpen] = useState(false);
  const [availableIsOpen, setAvailableIsOpen] = useState(false);

  return (
    userRole === roles.OWNER && (
      <Box display="flex" justifyContent="space-around" gridGap={16}>
        <Box display="flex" alignItems="flex-end">
          <Info
            onIconClick={() => setBalanceIsOpen(true)}
            infoName={<FormattedMessage id="userBalance" />}
            infoValue={Number(funds?.total_funds) || 0}
            textDirection={textDirection}
            size={size}
          />

          <BalanceDialog
            isOpen={balanceIsOpen}
            onClose={() => {
              setBalanceIsOpen(false);
            }}
          />
        </Box>
        <Box display="flex" alignItems="flex-end">
          <Info
            onIconClick={() => setAvailableIsOpen(true)}
            infoName={
              <FormattedMessage
                id="userFoundsAvailable"
                defaultMessage="Disponible: "
              />
            }
            infoValue={Number(funds?.available_funds) || 0}
            textDirection={textDirection}
            size={size}
          />
          <AvailableDialog
            isOpen={availableIsOpen}
            onClose={() => {
              setAvailableIsOpen(false);
            }}
          />
        </Box>
      </Box>
    )
  );
};

export default SrUserBalance;
